import React from 'react';
import PropTypes from 'prop-types';
import { themeIdentifier } from '../../utils/diagramIdentifierName';
import * as pitches from './Pitches';
import * as themes from './Themes';
import DiagramCreatorOptionTile from './DiagramCreatorOptionTile';
import SpinLoader from '../Global/Loaders/SpinLoader';

const DiagramCreatorThemeSelect = ({ options, changeTheme }) => (
  <div className="diagram-creator-theme-select">
    <h2 className="h1 color-white fw-medium">Pick your theme</h2>

    {options ? (
      <ul className="tile-btns-container row">
        {options &&
          options.map((option) => {
            const themeObjectRef = themeIdentifier(option.value);
            const theme = themes[themeObjectRef];
            const themeClass = theme.class;

            return (
              <li key={option.value} className="col-md-6">
                <DiagramCreatorOptionTile
                  classes={themeClass}
                  onClick={e => changeTheme(e, option)}
                  image={pitches.PITCH_7[themeClass].canvasImage}
                >
                  <h3 className="tile-btn__title card-link__text-change h2 fw-medium">{option.label}</h3>
                  <p className="text-grey no-margin">{option.description}</p>
                </DiagramCreatorOptionTile>
              </li>
            );
          })
        }
      </ul>
    ) : (
      <SpinLoader positionStatic />
    )}
  </div>
);

DiagramCreatorThemeSelect.propTypes = {
  options: PropTypes.array,
  changeTheme: PropTypes.func,
};

export default DiagramCreatorThemeSelect;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramCreatorThemeSelect.js